import Link from 'next/link';

import { CategoryMegaMenuSubCategoryColumnProps } from './models';

export const CategoryMegaMenuSubCategoryColumn = ({ subCategory, isDark, onNavigate }: CategoryMegaMenuSubCategoryColumnProps) => (
    <div className='min-w-0'>
        <Link
            href={subCategory.href}
            onClick={onNavigate}
            className={`mb-2 block truncate text-sm font-bold no-underline transition-colors
                ${isDark ? 'text-neutral-100 hover:text-white' : 'text-[#101828] hover:text-primary'}`}>
            {subCategory.name}
        </Link>

        {subCategory.children.length ? (
            <ul className='m-0 flex list-none flex-col gap-1 p-0'>
                {subCategory.children.map((child) => (
                    <li key={child.id}>
                        <Link
                            href={child.href}
                            onClick={onNavigate}
                            className={`block truncate text-[11px] font-normal leading-5 no-underline transition-colors
                                ${isDark ? 'text-neutral-400 hover:text-neutral-200' : 'text-[#667085] hover:text-primary'}`}>
                            {child.name}
                        </Link>
                    </li>
                ))}
            </ul>
        ) : null}
    </div>
);
